export const FETCH_CART_PRODUCTS = "FETCH_CART_PRODUCTS";
export const FETCH_CART_PRODUCTS_SUCCESS = "FETCH_CART_PRODUCTS_SUCCESS";
export const FETCH_CART_PRODUCTS_ERROR = "FETCH_CART_PRODUCTS_ERROR";

export const DECREASE_INCREASE_CART_PRODUCTS =
  "DECREASE_INCREASE_CART_PRODUCTS";
export const REMOVE_PRODUCT_IN_CART = "REMOVE_PRODUCT_IN_CART";
export const UPDATE_CART_PRODUCTS = "UPDATE_CART_PRODUCTS";
export const USE_PROMOTION_CODE = "USE_PROMOTION_CODE";
export const USE_PROMOTION_CODE_ERROR = "USE_PROMOTION_CODE_ERROR";
export const USE_PROMOTION_CODE_SUCCESS = "USE_PROMOTION_CODE_SUCCESS";
export const REMOVE_CART_PRODUCTS = "REMOVE_CART_PRODUCTS";
export const REMOVE_PROMOTION_CODE = "REMOVE_PROMOTION_CODE";
export const REMOVE_PROMOTION_CODE_SUCCESS = "REMOVE_PROMOTION_CODE_SUCCESS";
export const REMOVE_PROMOTION_CODE_ERROR = "REMOVE_PROMOTION_CODE_ERROR";

export const CHANGE_STATUS_IS_HAVE_SETUP_SERVICE =
  "CHANGE_STATUS_IS_HAVE_SETUP_SERVICE";

export const APPLY_DSP_CODE = "APPLY_DSP_CODE";
export const APPLY_DSP_CODE_SUCCESS = "APPLY_DSP_CODE_SUCCESS";
export const APPLY_DSP_CODE_ERROR = "APPLY_DSP_CODE_ERROR";
export const REMOVE_DSP_CODE = "REMOVE_DSP_CODE";
export const REMOVE_DSP_CODE_SUCCESS = "REMOVE_DSP_CODE_SUCCESS";
export const REMOVE_DSP_CODE_ERROR = "REMOVE_DSP_CODE_ERROR";

export const HAS_CROSS_SELL_ADDED =
  "HAS_CROSS_SELL_ADDED";

export const RESET_ERROR_CART = "RESET_ERROR_CART";

export const fetchCartProducts = (code?: string[], dspCode?: string, hasBuyMoreGetMore?: boolean, checkAction?: any) => ({
  type: FETCH_CART_PRODUCTS,
  code,
  dspCode,
  hasBuyMoreGetMore,
  checkAction,
});

export const removePromotionCode = ({ code, hasBuyMoreGetMore }: { code?: string[], hasBuyMoreGetMore?: boolean }) => ({
  type: REMOVE_PROMOTION_CODE,
  code,
  hasBuyMoreGetMore
});

export const fetchCartProductsOnSuccess = (
  cart: any,
  code?: any,
  checkAction?: any,
  dspCode?: string,
) => {
  return {
    type: FETCH_CART_PRODUCTS_SUCCESS,
    cart,
    code,
    checkAction,
    dspCode,
  };
};

export const fetchCartProductsOnError = (error: any, checkAction?: any) => ({
  type: FETCH_CART_PRODUCTS_ERROR,
  error,
  checkAction,
});

export const descreaseIncreaseCartProducts = (
  product: any,
  sign: string,
  code?: string[],
  dspCode?: string,
  hasBuyMoreGetMore?: boolean
) => ({
  type: DECREASE_INCREASE_CART_PRODUCTS,
  product,
  sign,
  code,
  dspCode,
  hasBuyMoreGetMore
});

export const updateCartProducts = (product: any, quantity: number, hasBuyMoreGetMore?: boolean) => ({
  type: UPDATE_CART_PRODUCTS,
  product,
  quantity,
  hasBuyMoreGetMore
});

// action call use promotion code:
export const applyPromotionCode = (code: string[], hasBuyMoreGetMore: boolean, checkAction: string) => ({
  type: USE_PROMOTION_CODE,
  code,
  hasBuyMoreGetMore,
  checkAction,
});

export const removeCartProducts = (code?: string[], dspCode?: string, hasBuyMoreGetMore?: boolean) => ({
  type: REMOVE_CART_PRODUCTS,
  code,
  dspCode,
  hasBuyMoreGetMore
});

export const onChangeStatusIsHaveSetupService = (
  productId: number,
  code?: string[],
) => ({
  type: CHANGE_STATUS_IS_HAVE_SETUP_SERVICE,
  productId,
  code,
});

// action apply DSP code
export const applyDSPCode = (dspCode: string, hasBuyMoreGetMore: boolean, checkAction: string) => ({
  type: APPLY_DSP_CODE,
  dspCode,
  hasBuyMoreGetMore,
  checkAction,
});

export const removeDspCode = (hasBuyMoreGetMore: boolean) => ({
  type: REMOVE_DSP_CODE,
  hasBuyMoreGetMore
});

export const hasCrossSellAdded = (hasCrossSellAdded: boolean) => ({
  type: HAS_CROSS_SELL_ADDED,
  hasCrossSellAdded,
});

// export const fetchCartWithDspCodeSuccess = (
//   cart: any,
//   dspCode?: string,
//   checkAction?: any,
// ) => {
//   return {
//     type: FETCH_CART_WITH_DSP_CODE_SUCCESS,
//     cart,
//     dspCode,
//     checkAction,
//   };
// };

// export const fetchCartWithDspCodeError = (error: any, checkAction?: any) => ({
//   type: FETCH_CART_WITH_DSP_CODE_ERROR,
//   error,
//   checkAction,
// });